import { render, staticRenderFns } from "./vxConfirm.vue?vue&type=template&id=70fdba8c&scoped=true&"
import script from "./vxConfirm.vue?vue&type=script&lang=js&"
export * from "./vxConfirm.vue?vue&type=script&lang=js&"
import style0 from "./vxConfirm.vue?vue&type=style&index=0&id=70fdba8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fdba8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70fdba8c')) {
      api.createRecord('70fdba8c', component.options)
    } else {
      api.reload('70fdba8c', component.options)
    }
    module.hot.accept("./vxConfirm.vue?vue&type=template&id=70fdba8c&scoped=true&", function () {
      api.rerender('70fdba8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/dividend/vxConfirm.vue"
export default component.exports